import { Location } from '@angular/common';
import { booleanAttribute, Component, inject, input } from '@angular/core';
import { Icon } from '../../icon/icon.component';

@Component({
  selector: 'lepi-page-modal-container',
  standalone: true,
  imports: [Icon],
  template: `<main
    [class.xl:hidden]="!desktop()"
    class="bg-white  absolute z-[999] inset-0 w-full min-h-screen h-full md:hidden slide">
    <section
      class="fixed top-0 z-10 flex justify-between w-full p-4 bg-white border-b border-gray-100">
      <lepi-icon
        (click)="goBack()"
        name="material-symbols:arrow-back-ios"
        class="bg-gray-700 cursor-pointer "
        size="sm" />

      <ng-content select="[icons]" />
    </section>
    <section class="z-50 h-full pb-20 pt-[49px]">
      <ng-content />
    </section>
    <section class="fixed bottom-0 w-full bg-white border-t border-gray-100">
      <ng-content select="[footer]" />
    </section>
  </main> `,
})
export class PageModalContainer {
  location = inject(Location);
  desktop = input(false, { transform: booleanAttribute });

  slideEnabled = input(true, { transform: booleanAttribute });

  goBack() {
    this.location.back();
  }
}
